import React from 'react';
import { Pane } from '@leverege/ui-elements';
import CarMaxZoneSearch from './CarMaxZoneSearch';
import S from './CarMaxZoneSearch.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CarMaxZoneInput(props) {
  const {
    eventData,
    onClose,
    formValues
  } = props;
  const namePath = {
    path: eventData.replace('/', '.'),
    key: 'name'
  };
  const barcodePath = {
    path: namePath.path.replace('.name', '.barcode'),
    key: 'barcode'
  };
  const idPath = {
    path: namePath.path.replace('.name', '.id'),
    key: 'kmxId'
  };
  const typePath = {
    path: namePath.path.replace('.name', '.type'),
    key: 'zoneType'
  };

  // stored value of input in imagine
  const nameValue = formValues['zone.kmx.name'];
  const barcodeValue = formValues['zone.kmx.barcode'];
  const idValue = formValues['zone.kmx.id'];
  const typeValue = formValues['zone.kmx.id'];
  const displayValue = nameValue ? `${nameValue} ${idValue} ${barcodeValue} ${typeValue}` : null;
  const updatePaths = [namePath, barcodePath, idPath, typePath];
  const onChange = zoneData => {
    const {
      onChange
    } = props;
    const data = {
      name: 'name'
    };
    const value = {
      name: zoneData.name
    };
    updatePaths.forEach(path => {
      value[`zone.${path.path}`] = zoneData[path.key];
      data[`zone.${path.path}`] = `zone.${path.path}`;
    });
    onChange({
      data,
      value
    });
  };
  return /*#__PURE__*/_jsx(Pane, {
    layout: "flex:colS",
    className: S.pane,
    children: /*#__PURE__*/_jsx(CarMaxZoneSearch, {
      "data-test-postfix": "CarMax Zone",
      hint: "Select CarMax Zone",
      onChange: onChange,
      onClose: onClose,
      value: displayValue
    })
  });
}